<template>
  <header class="
    h-11 in-car:h-20
    w-full
    sticky top-0 left-0 bg-ryd-background dark:bg-darkMain
    z-20 f-roboto"
  >
    <div class="relative h-11 in-car:h-20 w-full flex justify-center items-center">
      <RydButton
        v-if="props.backBtnVisible"
        theme="custom"
        class="p-0 min-w-min absolute left-0 w-11 "
        data-cy="backButton"
        :name="props.backButtonName"
        @click="$emit('backButtonClick')"
      >
        <RydIcon icon="symbols/arrow-back" :class="iconColor" isCustomColor class="in-car:w-20 in-car:h-20" />
      </RydButton>
      <h3
        id="topBarTitle"
        class="flex justify-center items-center h-full font-bold
        fs-16 in-car:fs-32"
        data-cy="headerTitle"
      >
        {{ props.title }}
      </h3>
      <div id="topBarIconRight" class="absolute right-0 top-0">
      </div>
      <RydButton
        v-if="props.rightBtnVisible"
        theme="custom"
        class="p-0 min-w-min absolute right-0 w-11 top-0"
        data-cy="backButton"
        :name="props.rightButtonName"
        @click="$emit('rightButtonClick')"
      >
        <RydIcon :icon="props.rightBtnIcon" />
      </RydButton>
    </div>
  </header>
</template>
<script setup lang="ts">
import RydButton from '@/components/RydButton/RydButton.vue';
import RydIcon from '@/components/RydIcon/RydIcon.vue';

const props = defineProps({
  backBtnVisible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  rightBtnVisible: {
    type: Boolean,
    default: false,
  },
  rightBtnIcon: {
    type: String,
    default: '',
  },
  iconColor: {
    type: String,
    default: 'text-text',
  },
  backButtonName: {
    type: String,
    default: '',
  },
  rightButtonName: {
    type: String,
    default: '',
  },
});
const emits = defineEmits(['backButtonClick', 'rightButtonClick']);
</script>
